import { getAccountBalance, GetBalanceParams } from "@/api/transactions";
import { useQuery } from "@tanstack/react-query";
import { transactionKeys } from "./keys";

export const useGetAccountBalance = (params: GetBalanceParams) => {
	return useQuery({
		queryKey: transactionKeys.balance(),
		refetchOnMount: "always",
		queryFn: () => getAccountBalance(params),
	});
};
